export const costEachColumnName = "Cost (ea)";
export const markupColumnName = "Markup";
